import React, { useState, useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import CRUDView from '../../../components/crud';
import BackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { useParams, useHistory } from 'react-router-dom';
import { GetCycle, AddCycle, UpdateCycle } from '../../../REST/administration';
import { FormView, Field } from '../../../components/form/Index';

const months = [
    { label: '1-January', value: 1 },
    { label: '2-February', value: 2 },
    { label: '3-March', value: 3 },
    { label: '4-April', value: 4 },
    { label: '5-May', value: 5 },
    { label: '6-June', value: 6 },
    { label: '7-July', value: 7 },
    { label: '8-August', value: 8 },
    { label: '9-September', value: 9 },
    { label: '10-October', value: 10 },
    { label: '11-November', value: 11 },
    { label: '12-December', value: 12 },
]

const days = [
    { label: '1st of Month', value: 1 },
    { label: '2st of Month', value: 2 },
    { label: '3th of Month', value: 3 },
    { label: '4th of Month', value: 4 },
    { label: '5th of Month', value: 5 },
    { label: '6th 0f Month', value: 6 },
    { label: '7th 0f Month', value: 7 },
    { label: '8th 0f Month', value: 8 },
    { label: '9th 0f Month', value: 9 },
    { label: '10th 0f Month', value: 10 },  
    { label: '11th of Month', value: 11 },
    { label: '12th of Month', value: 12 },
    { label: '13th of Month', value: 13 },
    { label: '14th 0f Month', value: 14 },
    { label: '15th 0f Month', value: 15 },
    { label: '16th 0f Month', value: 16 },
    { label: '17th 0f Month', value: 17 },
    { label: '18th 0f Month', value: 18 },
    { label: '19th 0f Month', value: 19 },    
    { label: '20th 0f Month', value: 20 },
    { label: '21th 0f Month', value: 21 },
    { label: '22th 0f Month', value: 22 },
    { label: '23th 0f Month', value: 23 },
    { label: '24th 0f Month', value: 24 },
    { label: '25th 0f Month', value: 25 },
    { label: '26th 0f Month', value: 26 },
    { label: '27th 0f Month', value: 27 },
    { label: '28th 0f Month', value: 28 },
    { label: '29th 0f Month', value: 29 },
    { label: '30th 0f Month', value: 30 },
    { label: '31th 0f Month', value: 31 },
    { label: 'Last 0f Month', value: -1 }
]

const backdays = [
    { label: 'Last 1 Month', value: 1 },
    { label: 'Last 3 Months', value: 2 },
    { label: 'Last 1 Year', value: 3 },
    { label: 'Other', value: 4 }
]

const types = [
    { label: 'Month', value: 1 },
    { label: 'Year', value: 2 },
]

const feeTypes = [
    { label: 'Fixed Amount', value: 'Fixed Amount' },
    { label: 'Percentage', value: 'Percentage' },
    { label: 'Daily Rate', value: 'Daily Rate' },
    { label: 'Monthly Rate', value: 'Monthly Rate' },
    { label: 'Fixed + Percentage', value: 'Fixed + Percentage' },
    { label: 'Tiered Aging', value: 'Tiered Aging' },
    { label: 'One-Time Penalty', value: 'One-Time Penalty' },
    { label: 'Escalating Penalty', value: 'Escalating Penalty' },
    { label: 'Contract Specific', value: 'Contract Specific' },
]


export default function NoticesView() {
    const { id } = useParams();
    const history = useHistory();

    const config = [
        { field: 'name', title: 'Invoice Cycle Name', type: 'text', isGrid: true },
        { field: 'description', title: 'Description', type: 'textarea', isGrid: true },
        { field: 'overdueFeeType', title: 'Fee Type', type: 'text', isGrid: true },
        { field: 'invoiceType', title: 'Invoice Type', type: 'text', isGrid: true },
        { field: 'gracePeriod', title: 'Grace Period', type: 'numeric', isGrid: true },
        { field: 'feeValue', title: 'Fee Value', type: 'numeric', isGrid: true },
        { field: 'minimumFee', title: 'Minimum Fee', type: 'numeric', isGrid: false },
        { field: 'maximumFee', title: 'Maximum Fee', type: 'numeric', isGrid: false },
        { field: 'effectiveDate', title: 'Effective Date', type: 'date', isGrid: true },
        { field: 'isActive', title: 'Active', type: 'checkbox', isGrid: true },
    ]

    const actions = [
        { icon: AddIcon, tooltip: 'New Record', isFreeAction: true, onClick: () => history.push('/admin/cycles/0') },
        { icon: EditIcon, tooltip: 'Edit Record', onClick: (evt, rowData) => history.push('/admin/cycles/' + rowData.id) }
    ]

    if (id)
        return <DetailsView />

    return <CRUDView link='#admin' url={`${process.env.REACT_APP_API_URL}/Cycle`} columns={config} title='Invoice Cycles' actions={actions}
        allowEdit={false}
        allowAdd={false}
        allowDelete={false}
        id='id' />
}

function DetailsView({ options = [] }) {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const history = useHistory();
    const formView = useRef(null);

    useEffect(() => {
        if (id !== 0 && id && id !== '0')
            GetCycle(id).then(response => setData(response.data))
        else
            setData({ isActive: true })
    }, [id])

    const normalizeCyclePayload = (result) => {
        const payload = { ...result };
        const feeType = payload.overdueFeeType;

        if (feeType !== 'Fixed + Percentage') {
            delete payload.fixedFeeValue;
            delete payload.percentageFeeValue;
        }

        if (feeType !== 'Tiered Aging') {
            delete payload.tieredAgingConfig;
        }

        if (feeType !== 'Escalating Penalty') {
            delete payload.escalatingPenaltyConfig;
        }

        if (feeType !== 'Contract Specific') {
            delete payload.contractSpecificConfig;
        }

        return payload;
    }

    const handleSave = () => {
        let result = formView.current.getResult();
        if (result) {
            const payload = normalizeCyclePayload(result)
            if (id === 0 || id === '0')
                handleAdd(payload)
            else
                handleUpdate(payload)
        }
    }

    const handleAdd = (result) => {
        AddCycle(result).then(response => {
            history.push('/admin/cycles/' + response.data.id)
        })
    }

    const handleUpdate = (result) => {
        UpdateCycle({ ...data, ...result })
    }

    const handleChange = () => {
        let result = formView.current.getCurrentResult();
        setData({ ...(data || {}), ...result });
    }

    const calcnoofbackdays  = () => {
        let result = formView.current.getCurrentResult();
        let days =0;
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();

        if(result.noOfBackDaysType==1){
            days = new Date(year, month, 0).getDate();
        } else if(result.noOfBackDaysType==3){
            days = ((year % 4 === 0 && year % 100 > 0) || year %400 == 0) ? 366 : 365;
        }else if(result.noOfBackDaysType==4){
            setData({ ...(data || {}), ...result });
        }
        setData({ ...(data || {}), ...result });
    }
  
    return <div className='row'><div className='col-6'>
        <FormView ref={formView} data={data}>
            <div className='row'><div className='col-12'>
                <Button className='float-right' variant="contained" color="secondary" startIcon={<BackIcon />} href='#admin/cycles'>Back</Button>
                <div className='clearfix' />
            </div></div>
            <Field.TextBox label='Name' required field='name' />
            <Field.TextArea label='Description' required field='description' />
            <Field.TextBox label='Generate Invoice Template Every' required field='frequency' />
            <div className='row'>
                <Field.DropDown className='col' changeEvt={handleChange} label='Time Frame' required field='frequencyType' options={types} />
                <Field.DropDown className='col' label='Date' required field='frequencyDate' unordered options={days} />
                {data && (data.frequencyType === 2 || data.frequencyType === '2') && <Field.DropDown unordered className='col' label='Month' required field='frequencyMonth' options={months} />}
            </div>
            <Field.TextBox label='Template Finalization Due' field='templateDue' required />
            <div className='row'>            
                 <Field.DropDown className='col' changeEvt={calcnoofbackdays} label='No Of Back Days Type' required field='noOfBackDaysType' options={backdays} />           
                 {data && (data.noOfBackDaysType === 4 || data.noOfBackDaysType === '4') && 
                 <Field.TextBox className='col' label='Event Pick up range (in days)'  field='noOfBackDays' /> }
                 <Field.CheckBox className='col' label='Allow Events' field='allowEvents' />
            </div>
            <Field.TextBox label='Payment Due' field='paymentDue' required />

            <h6 className='mt-3'>Overdue Fee Settings</h6>
            <Field.DropDown changeEvt={handleChange} label='Fee Type' field='overdueFeeType' options={feeTypes} />
            <div className='row'>
                <Field.TextBox className='col' label='Grace Period (Days)' field='gracePeriod' number />
                <Field.TextBox className='col' label='Fee Value' field='feeValue' number />
                <Field.TextBox className='col' label='Invoice Type' field='invoiceType' />
            </div>
            <div className='row'>
                <Field.TextBox className='col' label='Minimum Fee' field='minimumFee' number />
                <Field.TextBox className='col' label='Maximum Fee' field='maximumFee' number />
                <Field.DatePicker className='col' label='Effective Date' field='effectiveDate' />
            </div>
            <Field.CheckBox label='Active Flag' field='isActive' />

            {data && data.overdueFeeType === 'Fixed + Percentage' && <div className='row'>
                <Field.TextBox className='col' label='Fixed Fee Value' required field='fixedFeeValue' number />
                <Field.TextBox className='col' label='Percentage Fee Value' required field='percentageFeeValue' number />
            </div>}

            {data && data.overdueFeeType === 'Tiered Aging' &&
                <Field.TextArea label='Tiered Aging Configuration' required field='tieredAgingConfig' />}

            {data && data.overdueFeeType === 'Escalating Penalty' &&
                <Field.TextArea label='Escalating Penalty Configuration' required field='escalatingPenaltyConfig' />}

            {data && data.overdueFeeType === 'Contract Specific' &&
                <Field.TextArea label='Contract Specific Configuration' required field='contractSpecificConfig' />}

            <div className='row'>
                <div className='col'>
                    <Button fullWidth variant='outlined' color='secondary' onClick={handleSave}>Save</Button>
                </div>
                <div className='col'>
                    <Button fullWidth variant='outlined' color='secondary' href='#admin/cycles'>Back</Button>
                </div>
            </div>
        </FormView >
    </div>
    </div>
}